// src/services/api/reversal.js
import { apiClient } from './base';

/**
 * Reverse a single order (removes from batch, resets to targetStatusKey — 'confirmed' or 'cancelled')
 */
export const reverseSingleOrder = async (orderId, targetStatusKey, orderStatusReasonKey) => {
  const response = await apiClient.post(`/reversal/orders/${orderId}`, {
    targetStatusKey,
    orderStatusReasonKey
  });
  return response.data;
};

/**
 * Reverse an entire packing batch (resets every order to targetStatusKey — 'confirmed' or 'cancelled')
 */
export const reversePackingBatch = async (batchId, targetStatusKey, orderStatusReasonKey) => {
  const response = await apiClient.post(`/reversal/packing-batches/${batchId}`, {
    targetStatusKey,
    orderStatusReasonKey
  });
  return response.data;
};
